import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

// Lazy-loaded components
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const NewRegister = React.lazy(() => import('./components/PWM/Auth/tennatRegister'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const NewLogin = React.lazy(() => import('./components/PWM/Auth/Login'))
const ForgetPWD = React.lazy(() => import('./components/PWM/Auth/ForgetPWD'))
const Resetpage = React.lazy(() => import('./components/PWM/Auth/Resetpage'))
const Clearance_approve_table = React.lazy(() =>
  import('./components/PWM/ClearanceApp/ClearanceApprovePage'),
)
const AdminLogin = React.lazy(() => import('./components/PMSadmin/Auth/AdminLogin'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

class App extends Component {
  renderRoutes = () => {
    if (process.env.REACT_APP_ADMIN_PANEL === 'true') {
      //  Admin Routes
      return (
        <>
          <Route exact path="/login" name="Admin Login Page" element={<AdminLogin />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </>
      )
    } else {
      // Tenant/Client Routes
      return (
        <>
          <Route exact path="/:id" name="Login Page" element={<NewLogin />} />
          <Route exact path="/register" name="Register Page" element={<NewRegister />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/forget" name="Forget Page" element={<ForgetPWD />} />
          <Route exact path="/reset/:id" name="Reset Page" element={<Resetpage />} />
          <Route
            exact
            path="/managestocks"
            name="Manage Stocks"
            element={<Clearance_approve_table />}
          />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </>
      )
    }
  }

  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>{this.renderRoutes()}</Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
